import React, { useContext, useEffect } from "react";

import { AttributesContext, AttributeGroupDataContext } from "../../../contexts/attributes";
import { findAdditionalInfo, findUpdateKey } from "./field-builder";
import { checkUpdate } from "../lib/attribute-data";
import { PREFIX_FOR_FIELDS } from "../../coding/lib/constants";

const AttributeInputField = ({
    Field,
    attribute,
    codingWipKey,
    photoWipKey,
    isGroup,
    disabled = false,
    prefix,
    useAttributes,
    isReadOnly,
    upc,
    selectedId,
    existingValue,
    hasReset,
    setHasReset,
    updateOverride,
    taskType,
}) => {
    const currentAttributeGroup = useContext(AttributeGroupDataContext);
    const currentAttributes = useContext(AttributesContext);

    const attributes = useAttributes ? useAttributes : isGroup ? currentAttributeGroup : currentAttributes;

    const { additionalInfo, componentType, required, displayedTooltip, uuid, validation } = attribute;
    const usePrefix = prefix ? `${PREFIX_FOR_FIELDS}${prefix}_` : PREFIX_FOR_FIELDS;
    const isTypeSelect = attribute.key === "addressType" || attribute.key === "preparationMethod" || attribute.key === "addressCountry";

    useEffect(() => {
        if (disabled) {
            return;
        }

        if (selectedId && isTypeSelect) {
            return updateAttribute(null, existingValue);
        }
    }, [selectedId]);

    useEffect(() => {
        if (hasReset) {
            attributes.reset();
            setHasReset(false);
        }
    }, [hasReset]);

    const updateAttribute = (name, value) => {
        if (disabled) {
            return;
        }

        if (selectedId && isTypeSelect && value !== existingValue) {
            //fix for select dropdown not updating on change
            attribute.defaultValue = value;
        }

        const addressUpdate = selectedId && existingValue && existingValue !== value;

        const hasUpdate = checkUpdate(attributes.data[uuid], value, componentType);

        if ((!hasUpdate && !addressUpdate) || (!value && value !== "" && typeof value !== "boolean")) {
            return;
        }

        const valueToSave = typeof value === "string" ? value.trim() : value;

        if (attributes.data.hasOwnProperty(uuid) || isGroup) {
            attributes.update(attribute, valueToSave);
        } else {
            attributes.add(attribute, valueToSave);
        }
    };
    const updateOn = { [findUpdateKey(componentType)]: updateAttribute };

    return (
        <Field
            upc={upc}
            isReadOnly={isReadOnly}
            key={`field_${uuid}`}
            id={`${usePrefix}${uuid}`}
            name={`${uuid}`}
            validation={validation}
            hint={displayedTooltip}
            required={required}
            disabled={disabled}
            dataType={componentType}
            defaultValue={attribute.defaultValue && selectedId ? attribute.defaultValue : attributes.data[uuid]}
            attribute={attribute}
            codingWipKey={codingWipKey}
            photoWipKey={photoWipKey}
            updateOverride={updateOverride}
            {...updateOn}
            updateMany={attributes.updateMany}
            lockable={attribute.lockable}
            {...findAdditionalInfo(componentType, additionalInfo, taskType)}
        />
    );
};

export default AttributeInputField;
